// extracted by mini-css-extract-plugin
export default {"wrap":"ProBadge_wrap__PXpd2","wrapSmall":"ProBadge_wrapSmall__JrH7q","img":"ProBadge_img__R1qth"};